<template>
  <div>
    <critical-dataset-slides
      v-if="!isFilter"
      :slides="datasetEntry.slides"
      @slides-changed="changeSlides"
      :user="user" :trip-start="tripStart"
      :timestamp="timestamp"
      :critical-slides-loaded="criticalSlidesLoaded"
      :critical-slides-failed="criticalSlidesFailed">
    </critical-dataset-slides>

    <v-card-subtitle class="mx-auto pt-0">
                  <span class="font-weight-bold subtitle-2 mx-n4 pt-0">
                    {{ $vuetify.lang.t(`$vuetify.criticalDataset.labels.${CriticalDatasetLabels.HUMAN}`) }}
                  </span>
    </v-card-subtitle>

    <critical-dataset-human class="mt-n5" :human-entry="datasetEntry.human"
                            @filter-value-changed="applyFilterChanges"
                            :is-filter="isFilter"></critical-dataset-human>

    <v-row class="mx-auto" no-gutters justify="start">
      <v-col cols="12" md="6">
        <v-card-subtitle class="mx-auto pt-md-0">
                  <span class="font-weight-bold subtitle-2 mx-n4">
                    {{ $vuetify.lang.t(`$vuetify.criticalDataset.labels.${CriticalDatasetLabels.LIGHT_CONDITIONS}`) }}
                  </span>
        </v-card-subtitle>
        <critical-dataset-light-conditions
          :light-conditions-entry="datasetEntry.lightConditions"
          @filter-value-changed="applyFilterChanges"
          :is-filter="isFilter"></critical-dataset-light-conditions>
      </v-col>
      <v-col cols="12" md="6">
        <v-card-subtitle class="mx-auto pt-md-0">
                  <span class="font-weight-bold subtitle-2 mx-n4">
                    {{ $vuetify.lang.t(`$vuetify.criticalDataset.labels.${CriticalDatasetLabels.ACTIONS}`) }}
                  </span>
        </v-card-subtitle>
        <critical-dataset-actions :actions-entry="datasetEntry.actions"
                                  @filter-value-changed="applyFilterChanges"
                                  :is-filter="isFilter"></critical-dataset-actions>
      </v-col>
    </v-row>

    <v-card-subtitle class="mx-auto pt-md-0">
                  <span class="font-weight-bold subtitle-2 mx-n4">
                    {{ $vuetify.lang.t(`$vuetify.criticalDataset.labels.${CriticalDatasetLabels.DETECTORS}`) }}
                  </span>
    </v-card-subtitle>

    <critical-dataset-detector :belt-entry="datasetEntry.belt" :phone-entry="datasetEntry.phone"
                               :food-entry="datasetEntry.food"
                               :smoke-entry="datasetEntry.smoke"
                               :hands-frame-entry="datasetEntry.handFrame"
                               @filter-value-changed="applyFilterChanges"
                               :is-filter="isFilter"
    ></critical-dataset-detector>

    <v-textarea v-if="!isFilter" v-model="datasetEntry.comment" auto-grow outlined rows="3" class="mb-md-0"
                :label="$vuetify.lang.t('$vuetify.map.criticalPopup.rejectDialog.rejectComment')"></v-textarea>
  </div>
</template>

<script>
import CriticalDatasetHuman from './criticalDatasetHuman'
import CriticalDatasetLightConditions from './criticalDatasetLightConditions'
import CriticalDatasetActions from './criticalDatasetActions'
import CriticalDatasetDetector from './criticalDatasetDetector'
import { CriticalDatasetEntry } from '../../../models/criticalDataset/CriticalDatasetEntry'
import { CriticalDatasetLabels } from '../../../enum'
import CriticalDatasetSlides from '@/components/map/criticalDataset/criticalDatasetSlides'

export default {
  name: 'CriticalDatasetForm',
  components: {
    CriticalDatasetSlides,
    CriticalDatasetDetector,
    CriticalDatasetActions,
    CriticalDatasetLightConditions,
    CriticalDatasetHuman
  },
  props: {
    datasetEntry: CriticalDatasetEntry,
    isFilter: {
      type: Boolean,
      default: false
    },
    criticalSlidesLoaded: Boolean,
    criticalSlidesFailed: Boolean,
    user: Number,
    tripStart: Number,
    timestamp: Number
  },
  methods: {
    applyFilterChanges (data) {
      if (data.isToggled) {
        this.datasetEntry.filters[data.datasetField].push(data.detectorField)
      } else {
        this.datasetEntry.filters[data.datasetField] = this.datasetEntry.filters[data.datasetField].filter(item => item !== data.detectorField)
      }
    },
    changeSlides(newSlides) {
      this.datasetEntry.slides = newSlides
    }
  },
  created () {
    this['CriticalDatasetLabels'] = CriticalDatasetLabels
  }
}
</script>

<style scoped>

</style>
